export enum ServiceProjectStatusEnum {
  NEW = 1,
  ACCEPTED = 2,
  REJECTED = 3,
  DONE = 4
}
